import type { GoalDiagram } from '@anqi/shared'
import { seatStyle } from './Board'

/**
 * 说明书里的小棋盘示意图。
 *
 * 和真棋盘共用 seatStyle，所以图上的颜色和形状与实际对局里完全一致 ——
 * 说明书里画个蓝三角、真棋盘上却是别的样子，那图只会造成混乱。
 *
 * 图本身是纯展示，但它的**数据**（GOAL_DIAGRAMS）被服务端测试拿真实判定
 * 函数验过：每张图都是真的达成局面，而且一颗子都不多。
 */
export function MiniBoard({ diagram }: { diagram: GoalDiagram }) {
  const { boardSize } = diagram
  const key = (r: number, c: number) => `${r},${c}`
  const mine = new Set(diagram.mine.map(([r, c]) => key(r, c)))
  const others = new Set(diagram.others.map(([r, c]) => key(r, c)))
  const blocks = new Set(diagram.blocks.map(([r, c]) => key(r, c)))
  const me = seatStyle(0)
  const foe = seatStyle(diagram.siegeTarget ?? 1)

  return (
    <div
      className="grid w-full max-w-[220px] gap-[1px] rounded bg-slate-700 p-[1px]"
      style={{ gridTemplateColumns: `repeat(${boardSize}, minmax(0, 1fr))`, aspectRatio: '1 / 1' }}
      role="img"
      aria-label={diagram.caption}
    >
      {Array.from({ length: boardSize }, (_, r) =>
        Array.from({ length: boardSize }, (_, c) => {
          const k = key(r, c)
          return (
            <div
              key={k}
              className="flex aspect-square items-center justify-center bg-slate-800 text-[11px] font-bold leading-none"
            >
              {mine.has(k) ? (
                <span className={me.text}>{me.glyph}</span>
              ) : others.has(k) ? (
                <span className={foe.text}>{foe.glyph}</span>
              ) : blocks.has(k) ? (
                <span className="text-slate-500">✕</span>
              ) : null}
            </div>
          )
        }),
      )}
    </div>
  )
}
